import { useMutation } from '@apollo/client';
import { OrganizationOvertimePeriodCreateInput } from '__generated__/graphql';
import { CREATE_ORGANIZATION_OVERTIME_PERIOD } from 'apollo/mutations/organization-overtime-period';
import { IPayrollData } from 'containers/onboarding/owner-onboarding/OwnerOnboardingPayrollSettings/OwnerOnboardingPayrollSettings';
import { cloneDeep } from 'lodash';
import { DateTime } from 'luxon';
import { useDispatch } from 'react-redux';
import { organizationSetAction } from 'store/actions';
import IOrganization from 'types/Organization';
import IOrganizationOvertimePeriod from 'types/OrganizationOvertimePeriod';
import { DayOfWeekValue } from 'types/enum/DayOfWeek';
import { isoTimeStampUtc } from 'utils/dateUtils';
import { uuid } from 'utils/uuidUtils';
import { useOrganization } from './store';

export default function useCreateOrganizationPayPeriodOvertime() {
  const dispatch = useDispatch();
  const org = useOrganization();
  const [createOrganizationPayPeriodOvertime] = useMutation<{
    createOrganizationOvertimePeriod: IOrganizationOvertimePeriod;
  }>(CREATE_ORGANIZATION_OVERTIME_PERIOD);

  async function createPayPeriodOvertime(data: IPayrollData) {
    const overtimeStartDay: DayOfWeekValue = data.overtimeStart ?? DayOfWeekValue.MONDAY;
    const currentDate = DateTime.utc().startOf('day');

    function setDayOfTheWeek(): DateTime {
      const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
      const targetDayOfWeek = daysOfWeek.indexOf(overtimeStartDay.toLowerCase()) + 1;
      const previousMostRecentWeekDate = currentDate.set({ weekday: targetDayOfWeek });

      return previousMostRecentWeekDate;
    }

    const startTime = setDayOfTheWeek().minus({ weeks: 8 }).toISO();

    const item: OrganizationOvertimePeriodCreateInput = {
      id: uuid(),
      organizationId: org.id!,
      startTime: startTime,
      createdOn: isoTimeStampUtc(),
      weeklyOvertime: 40,
    };

    const result = await createOrganizationPayPeriodOvertime({ variables: { organizationOvertimePeriod: item } });

    if (result.data) {
      const newOrg = cloneDeep(org);
      newOrg.organizationOvertimePeriods = newOrg.organizationOvertimePeriods!.concat(
        result.data.createOrganizationOvertimePeriod
      );
      dispatch(organizationSetAction(newOrg as IOrganization));
    }

    return result.data?.createOrganizationOvertimePeriod;
  }

  return { createPayPeriodOvertime };
}
